import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import {
  Breadcrumb,
  Flex,
  Row,
  Col,
  Space,
  Image,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  Button,
  Empty,
  ColorPicker,
  message,
  Switch,
  Tabs,
  Modal,
  Spin
} from "antd";
import {
  PlusOutlined,
  StarOutlined,
  EyeOutlined,
  UploadOutlined,
  LoadingOutlined,
  DatabaseOutlined,
  EditOutlined,
  InfoCircleOutlined,
  GiftOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { getApi, postApi, getParamsApi } from "../services/api.jsx";
import magic from "../assets/img/magic.png";
import ReactQuill from "react-quill";
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";
import "react-quill/dist/quill.snow.css";
import TabPane from "antd/es/tabs/TabPane.js";
import dayjs from "dayjs";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Criteria from '../components/Criteria';

const s3BaseURL = process.env.REACT_APP_S3_BASE_URL;


const BadgeEdit = () => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const rewardImageURL = Form.useWatch("rewardImageURL", form);
  const [buttonColor, setButtonColor] = useState("#F35454");
  const [buttonTextColor, setButtonTextColor] = useState("#ffffff");
  const [fontColor, setFontColor] = useState("#ffffff");
  const [backgroundColor, setBackgroundColor] = useState("#0E0F11");
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [backgroundImageURL, setBackgroundImageURL] = useState();
  const [badgeStatus, setBadgeStatus] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [badgeData, setBadgeData] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [dataSourceList, setDataSourceList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formValues, setFormValues] = useState();
  const [recordCount, setRecordCount] = useState(0);
  const [headlineFontColor, setHeadlineFontColor] = useState("#ffffff");
  const [rewardHeadlineFontColor, setRewardHeadlineFontColor] = useState("#ffffff");
  const [rewardDescriptionFontColor, setRewardDescriptionFontColor] = useState("#ffffff");
  const [criteriaGroups, setCriteriaGroups] = useState([]);
  const [generatedSQL, setGeneratedSQL] = useState('');
  const [columnNames, setColumnNames] = useState([]);
  const [operators, setOperators] = useState([
    '=', '<>', '>', '>=', '<', '<=',
    'IN', 'NOT IN', 'LIKE', 'NOT LIKE',
    'CONTAINS', 'NOT CONTAINS',
    'IS NULL', 'IS NOT NULL',
    'BETWEEN', 'NOT BETWEEN'
  ]);
  const [columnTypes, setColumnTypes] = useState({});
  const [selectionMetadata, setSelectionMetadata] = useState({});
  const [isColumnLoading, setIsColumnLoading] = useState(false);
  const [isMetaDataLoading, setIsMetaDataLoading] = useState(false);

  const { id } = useParams();
  const getBadgeData = (badgeId) => {
    setLoading(true);
    const params = { id: badgeId };
    getParamsApi(`/badge/${badgeId}`, params)
      .then((response) => {
        setBadgeData(response);
        setLoading(false);
        setImageUrl(response.imageURL);
      })
      .catch((error) => {
        console.error("Error fetching badge data:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getBadgeData(id);
  }, [id]);

  useEffect(() => {
    getDataSourceList();
  }, []);

  const getDataSourceList = () => {
    getApi("/badge/datasource")
      .then((dataSources) => {
        setDataSourceList(dataSources);
      })
      .catch((ex) => {
        console.error("Error fetching datasource list:", ex);
      });
  };

  useEffect(() => {
    if (badgeData) {
      form.setFieldsValue({
        ...badgeData,
        publishDate: badgeData.publishDate ? dayjs(badgeData.publishDate) : undefined,
        expireDate: badgeData.expireDate ? dayjs(badgeData.expireDate) : undefined,
      });

      // Renkleri güncelle
      if (badgeData.backgroundColor) {
        setBackgroundColor(badgeData.backgroundColor);
      }
      
      if (badgeData.fontColor) {
        setFontColor(badgeData.fontColor);
      }
      
      if (badgeData.headlineFontColor) {
        setHeadlineFontColor(badgeData.headlineFontColor);
      }
      
      if (badgeData.buttonColor) {
        setButtonColor(badgeData.buttonColor);
      }

      if (badgeData.buttonTextColor) {
        setButtonTextColor(badgeData.buttonTextColor);
      }

      // Reward renkleri de ekle
      if (badgeData.rewardHeadlineFontColor) {
        setRewardHeadlineFontColor(badgeData.rewardHeadlineFontColor);
      }

      if (badgeData.rewardDescriptionFontColor) {
        setRewardDescriptionFontColor(badgeData.rewardDescriptionFontColor);
      }

      // Image URL'leri güncelle
      if (badgeData.imageURL) {
        setImageUrl(badgeData.imageURL);
      }

      if (badgeData.backgroundImageURL) {
        setBackgroundImageURL(badgeData.backgroundImageURL);
      }

      if (badgeData.dataSource) {
        handleDataSourceChange(badgeData.dataSource).then(() => {
          if (badgeData.selectionCriteria) {
            setGeneratedSQL(badgeData.selectionCriteria);
            const parsedGroups = parseSQLToCriteriaGroups(badgeData.selectionCriteria);
            setCriteriaGroups(parsedGroups);
          }
        });
      }
    }
  }, [form, badgeData]);

  const handleColorChange = (color, setter) => {
    const hexValue = typeof color === "string" ? color : color?.toHexString();
    setter(hexValue);
  };
  const handleCategoryChange = (value) => {
    const selectedCategoryName = value;
    const selectedCategory = categoryList.find(
      (category) => category.name === selectedCategoryName
    );
    if (selectedCategory) {
      const selectedCategoryId = selectedCategory.id;
      setCategoryId(selectedCategoryId);
    }
  };

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/webp";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG/WEBP file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const [previewData, setPreviewData] = useState({
    headline: "",
    description: "",
    imageURL: "",
    videoURL: "",
    bacgroundColor: "",
    font: "",
    fontColor: "",
    buttonLinkURL: "",
    buttonName: "",
    buttonColor: "",
    buttonTextColor: "",
  });


  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "code"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false
    },
    keyboard: {
      bindings: {
        handleEnter: {
          key: 13,
          handler: function(range, context) {
            if (context.format.header) {
              this.quill.format('header', context.format.header);
            }
            return true;
          }
        }
      }
    }
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
  ];

  const TextEditor = ({ value, onChange, placeholder }) => {
    const handleChange = (content) => {
      const cleanContent = content.replace(/<p><\/p>\s*<h[1-6]/g, '<h');
      if (onChange) {
        onChange(cleanContent);
      }
    };

    return (
      <ReactQuill
        theme="snow"
        value={value || ""}
        modules={modules}
        formats={formats}
        onChange={handleChange}
        placeholder={placeholder}
      />
    );
  };

  const getCategoryList = () => {
    getApi("/category/list").then((categoryList) => {
      setCategoryList(categoryList);
    });
  };

  const handleFormSubmit = (values) => {
    const requiredFields = ["dataSource", "selectionCriteria"];
    const missingFields = requiredFields.filter(field => !values[field]);

    if (missingFields.length > 0) {
      Swal.fire({
        title: "Error!",
        text: "Please enter data into the required fields before saving!",
        icon: "error",
      });
      return;
    }

    setFormValues(values);
    let criteriaCountURL = "/badge/criteriaCount?";
    if (values.dataSource) {
        criteriaCountURL += "dataSource=" + encodeURIComponent(values.dataSource);
    }
    if (generatedSQL) {
        const encodedSQL = encodeURIComponent(generatedSQL);
        criteriaCountURL += "&selectionCriteria=" + encodedSQL;
    }

    setLoading(true);
    getApi(criteriaCountURL)
      .then((count) => {
        setRecordCount(count);
        setIsModalVisible(true);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: "Error on checking criteria record count",
          error,
          icon: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const categoryUpdatedId = categoryId ? categoryId : badgeData.categoryId;
  const updateBadge = () => {
    const values = {
      ...formValues,
      publishDate: formValues.publishDate
        ? formValues.publishDate.toDate()
        : undefined,
      expireDate: formValues.expireDate
        ? moment(formValues.expireDate.format("YYYY-MM-DD")).toDate()
        : undefined,
    };

    const rewardValues = {
      rewardHeadline: values.rewardHeadline,
      rewardHeadlineFontColor: values.rewardHeadlineFontColor,
      rewardHeadlineFontSize: values.rewardHeadlineFontSize,
      rewardDescription: values.rewardDescription,
      rewardDescriptionFontColor: values.rewardDescriptionFontColor,
      rewardDescriptionFontSize: values.rewardDescriptionFontSize,
    };

    setLoading(true);
    const updatedBadgeData = {
      ...badgeData,
      ...values,
      ...rewardValues,
      lastUpdatedBy: localStorage.getItem("userEmail"),
      imageURL: imageUrl,
      backgroundImageURL: backgroundImageURL,
      headlineFontColor: values.headlineFontColor,
      headlineFontSize: values.headlineFontSize,
      fontSize: values.fontSize,
      categoryId: categoryUpdatedId,
    };

    // Base64 Control
    if ("imageURL" && "backgroundImageURL" in values) {
      delete values.imageUrl;
      delete values.backgroundImageURL;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'badge_update',
      'badge_id': badgeData.id,
      'badge_name': badgeData.name,
      'category': badgeData.type,
      'user_email': localStorage.getItem("userEmail"),
      'update_timestamp': new Date().toISOString(),
      'ga4_measurement_id': 'G-EC4X5M443P'
    });

    if (window.gtag) {
      window.gtag('event', 'badge_update', {
        'badge_id': badgeData.id,
        'badge_name': badgeData.name,
        'category': badgeData.type,
        'user_email': localStorage.getItem("userEmail"),
        'update_timestamp': new Date().toISOString()
      });
    }

    postApi("/badge", updatedBadgeData)
      .then((data) => {
        Swal.fire({
          title: "Success!",
          text: "Badge Updated!",
          icon: "success",
        });
        /*navigate("/dashboard");*/
      })
      .catch((error) => {
        console.error("Error updating badge:", error);
        Swal.fire({
          title: "Error!",
          text: "Error updating badge",
          error,
          icon: "error",
        });
      })
      .finally(() => {
        setLoading(false);
        setIsModalVisible(false);
      });
  };

  const badgePreview = () => {
    form
      .validateFields([
        "headline",
        "description",
        "imageURL",
        "backgroundImageURL",
        "videoURL",
        "buttonName",
        "buttonTextColor",
        "buttonColor",
        "buttonLinkURL",
      ])
      .then((values) => {
        setPreviewData(values);
      })
      .catch((error) => {
        console.log("Error in form:", error);
      });
  };

  const badgeFormStatusControl = () => {
    const values = form.getFieldsValue(["dataSource", "selectionCriteria"]);
    if (values.dataSource && values.selectionCriteria) {
      setBadgeStatus("success");
    } else {
      setBadgeStatus("error");
    }
  };

  const handleFormValuesChange = () => {
    badgePreview();
    badgeFormStatusControl();
  };
  const handleBadgeImageChange = (info) => {
    if (info.file.status === "uploading") {
      return;
    }
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (url) => {
        let imageUrl = s3BaseURL + info.file.originFileObj.name;
        setImageUrl(imageUrl);
      });
    }
  };
  const handleRemoveBadgeImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setImageUrl(undefined);
    form.setFieldValue("imageURL", undefined);
    handleFormValuesChange();
  };
  const handleRemoveRewardImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    form.setFieldValue("rewardImageURL", undefined);
    handleFormValuesChange();
  };
  const handleBackgroundImageChange = (info) => {
    if (info.file.status === "uploading") {
      return;
    }
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (url) => {
        let backgroundImageURL = s3BaseURL + info.file.originFileObj.name;
        setBackgroundImageURL(backgroundImageURL);
      });
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const uploadImage = async ({ file, onSuccess, onError }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      postApi("/file", formData, "multipart/form-data").then((data) => {
        onSuccess(data, file);
      });
      Swal.fire({
        title: "Success!",
        text: `${file.name} uploaded successfully`,
        icon: "success",
      });
    } catch (error) {
      onError(error);
      Swal.fire({
        title: "Error!",
        text: `${file.name} upload failed`,
        icon: "error",
      });
    }
  };
  const uploadVideo = async ({ file, onSuccess, onError }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      
      const response = await postApi("/file/multipart", formData, "multipart/form-data");
      
      onSuccess(response, file);
      
      const videoUrl = `https://orlando-magic-badge-dev1.s3.amazonaws.com/${file.name}`;
      form.setFieldValue('videoURL', videoUrl);
      badgePreview();
      
      Swal.fire({
        title: "Success!",
        text: `${file.name} uploaded successfully`,
        icon: "success",
      });
    } catch (error) {
      onError(error);
      Swal.fire({
        title: "Error!",
        text: `${file.name} upload failed`,
        icon: "error",
      });
    }
  };
  const isYouTubeURL = (url) => {
    return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+/.test(url);
  };
  useEffect(() => {
    getCategoryList();
  }, []);
  const props = {
    beforeUpload: (file) => {
      const isPNG = file.type === "image/png";
      if (!isPNG) {
        message.error(`${file.name} is not a png file`);
      }
      return isPNG || Upload.LIST_IGNORE;
    },
    onChange: (info) => {
      console.log(info.fileList);
    },
  };
  const handleRemoveBackgroundImage = () => {
    setBackgroundImageURL("");
  };

  const parseSQLToCriteriaGroups = (sql) => {
    if (!sql || sql.trim() === '') {
      return [{
        id: uuidv4(),
        type: 'group',
        logicType: 'And',
        isNot: false,
        criteria: []
      }];
    }


    try {
      let cleanSql = sql.trim();
      if (cleanSql.startsWith('(') && cleanSql.endsWith(')')) {
        let depth = 0;
        for (let i = 0; i < cleanSql.length; i++) {
          if (cleanSql[i] === '(') depth++;
          else if (cleanSql[i] === ')') depth--;

          if (i > 0 && depth === 0 && i < cleanSql.length - 1) {
            break;
          }
        }

        if (depth === 0) {
          cleanSql = cleanSql.substring(1, cleanSql.length - 1).trim();
        }
      }

      const hasAnd = / AND /i.test(cleanSql);
      const hasOr = / OR /i.test(cleanSql);
      const logicType = hasAnd ? 'And' : hasOr ? 'Or' : 'And';

      const criteria = parseConditions(cleanSql, logicType);

      return [{
        id: uuidv4(),
        type: 'group',
        logicType: logicType,
        isNot: false,
        criteria: criteria
      }];

    } catch (error) {
      console.error('Error parsing SQL:', error);
      return [{
        id: uuidv4(),
        type: 'group',
        logicType: 'And',
        isNot: false,
        criteria: []
      }];
    }
  };

  const parseConditions = (sql, logicType) => {
    const conditions = [];
    let currentCondition = '';
    let depth = 0;
    let i = 0;

    while (i < sql.length) {
      if (sql[i] === '(') depth++;
      else if (sql[i] === ')') depth--;

      if (depth === 0) {
        if (logicType === 'And' &&
          i <= sql.length - 5 &&
          sql.substring(i, i + 5).toUpperCase() === ' AND ') {
          conditions.push(currentCondition.trim());
          currentCondition = '';
          i += 5;
          continue;
        } else if (logicType === 'Or' &&
          i <= sql.length - 4 &&
          sql.substring(i, i + 4).toUpperCase() === ' OR ') {
          conditions.push(currentCondition.trim());
          currentCondition = '';
          i += 4;
          continue;
        }
      }

      currentCondition += sql[i];
      i++;
    }

    if (currentCondition.trim()) {
      conditions.push(currentCondition.trim());
    }

    return conditions.map(condition => parseCondition(condition)).filter(c => c !== null);
  };

  const parseCondition = (condition) => {
    try {

      if (condition.toUpperCase().startsWith('(NOT (') && condition.endsWith('))')) {
        const innerExpr = condition.substring(6, condition.length - 2).trim();

        const innerCriteria = parseCondition(innerExpr);
        if (!innerCriteria) return null;

        return {
          id: uuidv4(),
          type: 'group',
          logicType: 'And',
          isNot: true,
          criteria: [innerCriteria]
        };
      }
      else if (condition.toUpperCase().startsWith('NOT (') && condition.endsWith(')')) {
        const innerExpr = condition.substring(5, condition.length - 1).trim();

        const innerCriteria = parseCondition(innerExpr);
        if (!innerCriteria) return null;

        return {
          id: uuidv4(),
          type: 'group',
          logicType: 'And',
          isNot: true,
          criteria: [innerCriteria]
        };
      }
      else if (condition.startsWith('(') && condition.endsWith(')')) {
        const innerExpr = condition.substring(1, condition.length - 1).trim();

        const hasAnd = / AND /i.test(innerExpr);
        const hasOr = / OR /i.test(innerExpr);
        const logicType = hasAnd ? 'And' : hasOr ? 'Or' : 'And';

        const innerCriteria = parseConditions(innerExpr, logicType);

        return {
          id: uuidv4(),
          type: 'group',
          logicType: logicType,
          isNot: false,
          criteria: innerCriteria
        };
      }
      else {
        return parseRule(condition);
      }
    } catch (error) {
      console.error('Error parsing condition:', condition, error);
      return null;
    }
  };


  const parseRule = (rule) => {
    try {

      const equalNumMatch = /^(\w+)\s*=\s*(\d+(?:\.\d+)?)$/i.exec(rule);
      if (equalNumMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: equalNumMatch[1],
          operator: '=',
          values: [equalNumMatch[2]]
        };
      }

      const equalStrMatch = /^(\w+)\s*=\s*['"]([^'"]+)['"]$/i.exec(rule);
      if (equalStrMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: equalStrMatch[1],
          operator: '=',
          values: [equalStrMatch[2]]
        };
      }

      const greaterNumMatch = /^(\w+)\s*>\s*(\d+(?:\.\d+)?)$/i.exec(rule);
      if (greaterNumMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: greaterNumMatch[1],
          operator: '>',
          values: [greaterNumMatch[2]]
        };
      }

      const lessNumMatch = /^(\w+)\s*<\s*(\d+(?:\.\d+)?)$/i.exec(rule);
      if (lessNumMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: lessNumMatch[1],
          operator: '<',
          values: [lessNumMatch[2]]
        };
      }

      const greaterEqualNumMatch = /^(\w+)\s*>=\s*(\d+(?:\.\d+)?)$/i.exec(rule);
      if (greaterEqualNumMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: greaterEqualNumMatch[1],
          operator: '>=',
          values: [greaterEqualNumMatch[2]]
        };
      }

      const lessEqualNumMatch = /^(\w+)\s*<=\s*(\d+(?:\.\d+)?)$/i.exec(rule);
      if (lessEqualNumMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: lessEqualNumMatch[1],
          operator: '<=',
          values: [lessEqualNumMatch[2]]
        };
      }

      const inMatch = /^(\w+)\s+IN\s+\(\s*([^)]+)\s*\)$/i.exec(rule);
      if (inMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: inMatch[1],
          operator: 'IN',
          values: inMatch[2].split(',').map(v => v.trim().replace(/^['"]|['"]$/g, ''))
        };
      }

      const notInMatch = /^(\w+)\s+NOT\s+IN\s+\(\s*([^)]+)\s*\)$/i.exec(rule);
      if (notInMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: notInMatch[1],
          operator: 'NOT IN',
          values: notInMatch[2].split(',').map(v => v.trim().replace(/^['"]|['"]$/g, ''))
        };
      }

      const likeMatch = /^(\w+)\s+LIKE\s+['"]([^'"]+)['"]$/i.exec(rule);
      if (likeMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: likeMatch[1],
          operator: 'LIKE',
          values: [likeMatch[2]]
        };
      }

      const notLikeMatch = /^(\w+)\s+NOT\s+LIKE\s+['"]([^'"]+)['"]$/i.exec(rule);
      if (notLikeMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: notLikeMatch[1],
          operator: 'NOT LIKE',
          values: [notLikeMatch[2]]
        };
      }

      const isNullMatch = /^(\w+)\s+IS\s+NULL$/i.exec(rule);
      if (isNullMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: isNullMatch[1],
          operator: 'IS NULL',
          values: []
        };
      }

      const isNotNullMatch = /^(\w+)\s+IS\s+NOT\s+NULL$/i.exec(rule);
      if (isNotNullMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: isNotNullMatch[1],
          operator: 'IS NOT NULL',
          values: []
        };
      }

      const betweenMatch = /^(\w+)\s+BETWEEN\s+(\d+(?:\.\d+)?)\s+AND\s+(\d+(?:\.\d+)?)$/i.exec(rule);
      if (betweenMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: betweenMatch[1],
          operator: 'BETWEEN',
          values: [betweenMatch[2], betweenMatch[3]]
        };
      }

      const notBetweenMatch = /^(\w+)\s+NOT\s+BETWEEN\s+(\d+(?:\.\d+)?)\s+AND\s+(\d+(?:\.\d+)?)$/i.exec(rule);
      if (notBetweenMatch) {
        return {
          id: uuidv4(),
          type: 'rule',
          columnName: notBetweenMatch[1],
          operator: 'NOT BETWEEN',
          values: [notBetweenMatch[2], notBetweenMatch[3]]
        };
      }

      console.warn('Unparseable rule:', rule);
      return null;
    } catch (error) {
      console.error('Error parsing rule:', rule, error);
      return null;
    }
  };

  const handleDataSourceChange = async (value) => {
    setIsColumnLoading(true);
    setIsMetaDataLoading(true);
    try {
      const columnsResponse = await getApi(`/badge/columnNames?datasource=${value}`);
      setColumnNames(columnsResponse);

      const columnTypesMap = {};
      columnsResponse.forEach(col => {
        columnTypesMap[col.columnName] = col.columnDataType;
      });

      setColumnTypes(columnTypesMap);

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsColumnLoading(false);
      setIsMetaDataLoading(false);
    }
  };

  const handleColumnChange = async (value, isSelection) => {
    if (!value) return;

    try {
      const dataSource = form.getFieldValue('dataSource');
      if (!dataSource) {
        message.error('Please select a datasource first!');
        return;
      }

      await getMetaData(dataSource, value, isSelection);
    } catch (error) {
      console.error('Error handling column change:', error);
    }
  };

  const getMetaData = async (datasource, columnName, isSelection) => {
    setIsMetaDataLoading(true);
    try {
      const response = await getApi(`/badge/metadata?datasource=${datasource}&columnName=${columnName}`);

      if (isSelection) {
        setSelectionMetadata(prev => ({
          ...prev,
          [columnName]: response
        }));
      }

      return response;
    } catch (error) {
      console.error('Error fetching metadata:', error);
      throw error;
    } finally {
      setIsMetaDataLoading(false);
    }
  };

  const generateSQL = useCallback((groups) => {

    const generateGroupSQL = (group) => {
      if (!group.criteria || group.criteria.length === 0) return '';

      const criteriaSQL = group.criteria.map(criteria => {
        if (criteria.type === 'group') {
          const nestedSQL = generateGroupSQL(criteria);
          return nestedSQL ? `(${nestedSQL})` : '';
        }

        if (!criteria.columnName || !criteria.operator) return '';
        if (['IS NULL', 'IS NOT NULL'].includes(criteria.operator)) {
          return `${criteria.columnName} ${criteria.operator}`;
        }
        if (!criteria.values || (!criteria.values[0] && !['IN', 'NOT IN'].includes(criteria.operator))) return '';

        const columnType = columnTypes[criteria.columnName];
  
        if (columnType === 'TIMESTAMP' || columnType === 'DATE') {
          if (['BETWEEN', 'NOT BETWEEN'].includes(criteria.operator)) {
            if (criteria.values.length === 2 && criteria.values[0] && criteria.values[1]) {
              return `${criteria.columnName} ${criteria.operator} '${criteria.values[0]}' AND '${criteria.values[1]}'`;
            }
            return '';
          }

          if (['=', '<>', '>', '>=', '<', '<='].includes(criteria.operator)) {
            if (criteria.values[0]) {
              return `${criteria.columnName} ${criteria.operator} '${criteria.values[0]}'`;
            }
            return '';
          }
        }

        const formatValue = (value) => {
          if (value === null || value === undefined || value === '') {
            return 'NULL';
          }

          const isNumeric = columnType === 'INTEGER' ||
            columnType === 'NUMBER' ||
            columnType === 'FLOAT' ||
            columnType === 'DECIMAL';

          if (isNumeric && !isNaN(Number(value))) {
            return value;
          }

          if (['LIKE', 'NOT LIKE'].includes(criteria.operator)) {
            return `'${value}'`;
          }

          if (['CONTAINS', 'NOT CONTAINS'].includes(criteria.operator)) {
            return `'${value}'`;
          }

          return `'${value}'`;
        };

        switch (criteria.operator) {
          case 'IN':
            if (!criteria.values || criteria.values.length === 0) {
              return `${criteria.columnName} IN (NULL)`;
            }
            return `${criteria.columnName} IN (${criteria.values.map(v => formatValue(v)).join(', ')})`;

          case 'NOT IN':
            if (!criteria.values || criteria.values.length === 0) {
              return `${criteria.columnName} NOT IN (NULL)`;
            }
            return `${criteria.columnName} NOT IN (${criteria.values.map(v => formatValue(v)).join(', ')})`;

          case 'BETWEEN':
          case 'NOT BETWEEN':
            if (!criteria.values || criteria.values.length < 2 || !criteria.values[0] || !criteria.values[1]) {
              return '';
            }
            return `${criteria.columnName} ${criteria.operator} ${formatValue(criteria.values[0])} AND ${formatValue(criteria.values[1])}`;

          case 'CONTAINS':
            return `CONTAINS(${criteria.columnName}, ${formatValue(criteria.values[0])})`;

          case 'NOT CONTAINS':
            return `NOT CONTAINS(${criteria.columnName}, ${formatValue(criteria.values[0])})`;

          case 'LIKE':
          case 'NOT LIKE':
            return `${criteria.columnName} ${criteria.operator} ${formatValue(criteria.values[0])}`;

          default:
            return `${criteria.columnName} ${criteria.operator} ${formatValue(criteria.values[0])}`;
        }
      }).filter(sql => sql !== '');

      if (criteriaSQL.length === 0) return '';

      let sql = criteriaSQL.join(` ${group.logicType} `);
      if (group.isNot) {
        sql = `NOT (${sql})`;
      }

      return group.criteria.some(c => c.type === 'group') ? `(${sql})` : sql;
    };

    const mainSQL = groups.map(group => generateGroupSQL(group))
      .filter(sql => sql !== '')
      .join(' AND ');

    return mainSQL || '';
  }, [columnTypes]);

  const resetBadgeInfoTab = () => {
    form.resetFields([
      "name",
      "headline",
      "headlineFontColor",
      "headlineFontSize",
      "type",
      "description",
      "hoverDescription",
      "videoURL",
      "uploadVideo",
      "altText",
      "backgroundColor",
      "backgroundImageURL",
      "font",
      "fontColor",
      "fontSize",
      "buttonName",
      "buttonLinkURL",
      "buttonColor",
      "buttonTextColor",
      "hasReward",
      "promoUuid",
      "isDisplayUnearned",
      "publishDate",
      "expireDate",
    ]);
    form.setFieldsValue({
      headlineFontColor: "#ffffff",
      backgroundColor: "#1E222B",
      fontColor: "#ffffff",
      buttonColor: "#ffffff",
      buttonTextColor: "#ffffff",
    });
    setButtonColor("#ffffff");
    setButtonTextColor("#ffffff");
    setFontColor("#ffffff");
    setBackgroundColor("#1E222B");
    setHeadlineFontColor("#ffffff");
  };

  const resetRewardTab = () => {
    form.resetFields([
      "rewardHeadline",
      "rewardHeadlineFontColor",
      "rewardHeadlineFontSize",
      "rewardDescription",
      "rewardDescriptionFontColor",
      "rewardDescriptionFontSize",
    ]);
    form.setFieldsValue({
      rewardHeadlineFontColor: "#ffffff",
      rewardDescriptionFontColor: "#ffffff",
    });
    setRewardHeadlineFontColor("#ffffff");
    setRewardDescriptionFontColor("#ffffff");
  };

  const resetData = () => {
    form.setFieldsValue({
      dataSource: undefined,
      selectionCriteria: '',
    });

    setCriteriaGroups([{
      id: uuidv4(),
      type: 'group',
      logicType: 'And',
      isNot: false,
      criteria: [{
        id: uuidv4(),
        type: 'rule',
        columnName: undefined,
        operator: undefined,
        values: []
      }]
    }]);
    setGeneratedSQL('');
    setBadgeStatus('error');
  };

  useEffect(() => {
    if (generatedSQL) {
      form.setFieldValue('selectionCriteria', generatedSQL);
    }
  }, [generatedSQL, form]);

  const handleDataTabUpdate = () => {
    const currentValues = form.getFieldsValue();

    currentValues.selectionCriteria = generatedSQL;

    handleFormSubmit(currentValues);
  };

  return (
    <div>
      <Flex
        gap="middle"
        align="center"
        justify="space-between"
        className="page-header"
      >
        <h2>
          {" "}
          <EditOutlined /> {badgeData.name}
        </h2>
        <Breadcrumb
          items={[
            {
              title: "Home",
            },
            {
              title: <a href="">Badge Editor</a>,
            },
          ]}
        />
      </Flex>

      <Row style={{ padding: "20px 10px" }}>
        <Col span={16}>
          <Form
            form={form}
            onFinish={handleFormSubmit}
            onValuesChange={handleFormValuesChange}
            scrollToFirstError
            name="validateOnly"
            layout="vertical"
            autoComplete="off"
          >
            <Tabs defaultActiveKey="1">
              <TabPane
                tab={
                  <span>
                    <StarOutlined className="me-5" />
                    Badge Info
                  </span>
                }
                key="1"
              >
                <Flex>
                  <Flex style={{ width: "45%", marginRight: "3%" }} vertical>
                    <Form.Item
                      name="imageURL"
                      label="Badge Image"
                      rules={[
                        { required: true, message: "Please upload image!" },
                      ]}
                    >
                      <Upload
                        name="imageURL"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        customRequest={uploadImage}
                        beforeUpload={beforeUpload}
                        onChange={handleBadgeImageChange}
                      >
                        {imageUrl ? (
                          <div style={{ position: "relative", width: "100%" }}>
                            <img
                              src={imageUrl}
                              alt="avatar"
                              style={{
                                width: "95%",
                              }}
                            />
                            <Button
                              danger
                              shape="circle"
                              size="small"
                              icon={<DeleteOutlined />}
                              title="Remove image"
                              onClick={handleRemoveBadgeImage}
                              style={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                              }}
                            />
                          </div>
                        ) : (
                          uploadButton
                        )}
                      </Upload>
                    </Form.Item>
                    <Form.Item
                      name="id"
                      value="sdfsdfsd"
                      rules={[
                        {
                          required: true,
                          message: "Please input badge number!",
                        },
                      ]}
                    >
                      <Input defaultValue={badgeData.id} disabled />
                    </Form.Item>
                    <Form.Item
                      name="name"
                      label="Badge Name"
                      rules={[
                        { required: true, message: "Please input badge name!" },
                      ]}
                    >
                      <Input placeholder="input badge name" />
                    </Form.Item>
                    <Form.Item
                      name="headline"
                      label="Headline"
                      rules={[
                        { required: true, message: "Please enter headline!" },
                      ]}
                    >
                      <Input
                        placeholder="input headline"
                        value={badgeData.headline}
                      />
                    </Form.Item>
                    <Flex>
                      <Form.Item
                        name="headlineFontColor"
                        style={{ width: "200px" }}
                        label="Headline Font Color"
                        getValueFromEvent={(color) => {
                          return "#" + color.toHex();
                        }}
                      >
                        <ColorPicker
                          showText
                          defaultValue="white"
                          value={headlineFontColor}
                          onChange={(color) => handleColorChange(color, setHeadlineFontColor)}
                        />
                      </Form.Item>

                      <Form.Item
                        name="headlineFontSize"
                        style={{ width: "200px", marginLeft: "20px" }}
                        label="Headline Font Size"
                      >
                        <Input
                          type="number"
                          min={1}
                          placeholder="Enter font size"
                          addonAfter="px"
                        />
                      </Form.Item>

                    </Flex>
                    <Form.Item
                      name="type"
                      label="Category"
                      rules={[
                        { required: true, message: "Please select category!" },
                      ]}
                    >
                      <Select
                        placeholder="Select badge category"
                        onChange={(value) => handleCategoryChange(value)}
                      >
                        {categoryList.map((category) => (
                          <Option key={category.id} value={category.name}>
                            {category.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="description"
                      label="Badge Description"
                      maxLength="100"
                      rules={[
                        {
                          required: true,
                          message: "Please input badge description!",
                        },
                      ]}
                    >
                      <TextEditor />
                    </Form.Item>
                    <Form.Item
                      name="hoverDescription"
                      label="Hover Badge Description"
                      maxLength="100"
                      rules={[
                        {
                          required: false                        },
                      ]}
                    >
                      <TextEditor />
                    </Form.Item>
              
                  </Flex>

                  <Flex vertical>
                    <Form.Item name="videoURL" label="Video/Image URL">
                      <Input placeholder="input embed video URL" />
                    </Form.Item>

                    <Form.Item name="uploadVideo" label="Upload Video">
                      <Upload
                        customRequest={uploadVideo}
                        showUploadList={true}
                      >
                        <Button icon={<UploadOutlined />}>Upload Video</Button>
                      </Upload>
                    </Form.Item>

                    <Form.Item name="altText" label="Alt Text">
                      <Input placeholder="input alt text " />
                    </Form.Item>
                    <Flex>
                      <Form.Item
                        name="backgroundColor"
                        className="ms-5"
                        label="Background Color"
                        getValueFromEvent={(color) => {
                          return "#" + color.toHex();
                        }}
                        rules={[
                          {
                            required: false,
                            message: "select background color!",
                          },
                        ]}
                      >
                        <ColorPicker
                          showText
                          defaultValue="#1E222B"
                          value={backgroundColor}
                          onChange={(color) =>
                            handleColorChange(color, setBackgroundColor)
                          }
                        />
                      </Form.Item>
                      <Form.Item
                        className="ms-5"
                        name="backgroundImageURL"
                        label="Background Image"
                        rules={[
                          { required: false, message: "Please select font!" },
                        ]}
                      >
                        <Upload
                          {...props}
                          showRemoveIcon={true}
                          onRemove={() => handleRemoveBackgroundImage()}
                          name="backgroundImageURL"
                          showUploadList={true}
                          customRequest={uploadImage}
                          beforeUpload={beforeUpload}
                          onChange={handleBackgroundImageChange}
                        >
                          <Button icon={<UploadOutlined />}>
                            Upload Image
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Flex>

                    <Flex>
                      <Form.Item
                        name="font"
                        style={{ width: "200px" }}
                        label="Font"
                        rules={[
                          { required: false, message: "Please select font!" },
                        ]}
                      >
                        <Select placeholder="select font">
                          <Option value="Poppins">Poppins</Option>
                          <Option value="Roboto">Roboto</Option>
                          <Option value="Custom">Custom</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="fontColor"
                        className="ms-5"
                        label="Font Color"
                        getValueFromEvent={(color) => {
                          return "#" + color.toHex();
                        }}
                        rules={[
                          {
                            required: false,
                            message: " select font color!",
                          },
                        ]}
                      >
                        <ColorPicker
                          showText
                          defaultValue="white"
                          value={fontColor}
                          onChange={(color) =>
                            handleColorChange(color, setFontColor)
                          }
                        />
                      </Form.Item>
                    </Flex>

                    <Form.Item
                      name="fontSize"
                      style={{ width: "200px" }}
                      label="Font Size"
                    >
                      <Input
                        type="number"
                        min={1}
                        placeholder="Enter font size"
                        addonAfter="px"
                      />
                    </Form.Item>

                    <Form.Item
                      name="buttonName"
                      label="Button Name"
                      rules={[
                        {
                          required: false,
                          message: "Please input Button Name!",
                        },
                      ]}
                    >
                      <Input placeholder="input button name" />
                    </Form.Item>
                    <Form.Item
                      name="buttonLinkURL"
                      label="Button URL"
                      rules={[
                        {
                          required: false,
                          message: "Please input Button URL!",
                        },
                      ]}
                    >
                      <Input addonBefore="https://" />
                    </Form.Item>
                    <Flex>
                      <Form.Item
                        name="buttonColor"
                        className="ms-5"
                        label="Button Color"
                        getValueFromEvent={(color) => {
                          return "#" + color.toHex();
                        }}
                        rules={[
                          {
                            required: false,
                            message: " select button color!",
                          },
                        ]}
                      >
                        <ColorPicker
                          showText
                          defaultValue="white"
                          value={buttonColor}
                          onChange={(color) =>
                            handleColorChange(color, setButtonColor)
                          }
                        />
                      </Form.Item>

                      <Form.Item
                        name="buttonTextColor"
                        className="ms-5"
                        label="Button Text Color"
                        getValueFromEvent={(color) => {
                          return "#" + color.toHex();
                        }}
                        rules={[
                          {
                            required: false,
                            message: "Select button text color!",
                          },
                        ]}
                      >
                        <ColorPicker
                          showText
                          defaultValue="white"
                          value={buttonColor}
                          onChange={(color) =>
                            handleColorChange(color, setButtonTextColor)
                          }
                        />
                      </Form.Item>
                    </Flex>
                    <Form.Item
                      name="hasReward"
                      label="Is there a reward for this badge?"
                    >
                      <Switch checkedChildren="Yes" unCheckedChildren="No" />
                    </Form.Item>
                    <Form.Item
                      name="promoUuid"
                      label="Promo UUID"
                      rules={[
                        {
                          required: false,
                          message: "Please input Promo UUID!",
                        },
                      ]}
                      initialValue={badgeData.promoUuid}
                    >
                      <Input placeholder="Enter Promo UUID" />
                    </Form.Item>
                    <Form.Item
                      name="isDisplayUnearned"
                      label="Display Badge Even Unearned?"
                    >
                      <Switch checkedChildren="Yes" unCheckedChildren="No" />
                    </Form.Item>
                    <Flex>
                      <Form.Item
                        className="me-5"
                        name="publishDate"
                        label="Publish Date"
                        rules={[
                          {
                            required: true,
                            message: "Please select publish date!",
                          },
                        ]}
                      >
                        <DatePicker showTime maxDate={dayjs("2028-01-01")} />
                      </Form.Item>
                      <Form.Item
                        label="Expire Date"
                        name="expireDate"
                        rules={[
                          {
                            required: false,
                            message: "Please select expiry date!",
                          },
                        ]}
                      >
                        <DatePicker maxDate={dayjs("2099-01-01")} />
                      </Form.Item>
                    </Flex>
                    <Form.Item>
                      <Space>
                        <Button
                          type="dashed"
                          shape="round"
                          danger
                          onClick={badgePreview}
                          icon={<EyeOutlined />}
                        >
                          Preview
                        </Button>
                        <Button
                          shape="round"
                          className="badge-btn-dark"
                          type="primary"
                          success
                          htmlType="submit"
                          icon={<StarOutlined />}
                        >
                          Update
                        </Button>
                        <Button
                          htmlType="button"
                          shape="round"
                          danger
                          onClick={resetBadgeInfoTab}
                        >
                          Reset
                        </Button>
                      </Space>
                    </Form.Item>
                  </Flex>
                </Flex>
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <DatabaseOutlined className="me-5" />
                    Data

                  </span>
                }
                key="2"
              >
                <Flex style={{ width: "90%" }} vertical>
                  <Form.Item
                    name="dataSource"
                    label="Datasource"
                    rules={[
                      { required: true, message: "Please select datasource!" },
                    ]}
                  >
                    <Select
                      placeholder="Select datasource"
                      onChange={(value) => handleDataSourceChange(value)}

                    >
                      {dataSourceList && dataSourceList.length > 0 ? dataSourceList.map((dataSource) => (
                        <Option
                          key={dataSource}
                          value={dataSource}
                          label={dataSource}
                        >
                          {dataSource}
                        </Option>
                      )) : null}
                    </Select>
                  </Form.Item>

                  <Form.Item name="selectionCriteria" hidden>
                    <Input />
                  </Form.Item>
                  {isColumnLoading ? (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                      <Spin tip="Loading column data..." />
                    </div>) : (
                    <Criteria
                      title="Selection Criteria"
                      required={true}
                      criteriaGroups={criteriaGroups}
                      setCriteriaGroups={setCriteriaGroups}
                      generateSQL={generateSQL}
                      setGeneratedSQL={setGeneratedSQL}
                      columnNames={columnNames}
                      operators={operators}
                      metadata={selectionMetadata}
                      onColumnChange={(value) => handleColumnChange(value, true)}
                      isColumnLoading={isColumnLoading}
                      isMetaDataLoading={isMetaDataLoading}
                      columnTypes={columnTypes}
                      isSelectionCriteria={true}
                      initialSQL={badgeData?.selectionCriteria || ''}
                    />

                  )}


                  <Form.Item>
                    <Space>
                      <Button
                        shape="round"
                        className="badge-btn-dark"
                        type="primary"
                        success
                        icon={<StarOutlined />}
                        onClick={handleDataTabUpdate}
                        loading={loading}
                      >
                        Update
                      </Button>
                      <Button
                        htmlType="button"
                        shape="round"
                        danger
                        onClick={resetData}
                      >
                        Reset
                      </Button>
                    </Space>
                  </Form.Item>
                </Flex>
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <GiftOutlined className="me-5" />
                    Reward
                  </span>
                }
                key="3"
              >
                <Flex style={{ width: "60%" }} vertical>
                  <Form.Item
                    name="rewardImageURL"
                    label="Reward Image"
                  >
                    <Upload
                      name="rewardImageURL"
                      listType="picture-card"
                      className="avatar-uploader"
                      showUploadList={false}
                      customRequest={uploadImage}
                      beforeUpload={beforeUpload}
                      onChange={(info) => {
                        if (info.file.status === "done") {
                          const imageUrl = s3BaseURL + info.file.originFileObj.name;
                          form.setFieldValue('rewardImageURL', imageUrl);
                        }
                      }}
                    >
                      {rewardImageURL ? (
                        <div style={{ position: "relative", width: "100%" }}>
                          <img
                            src={rewardImageURL}
                            alt="reward"
                            style={{ width: '95%' }}
                          />
                          <Button
                            danger
                            shape="circle"
                            size="small"
                            icon={<DeleteOutlined />}
                            title="Remove image"
                            onClick={handleRemoveRewardImage}
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                            }}
                          />
                        </div>
                      ) : (
                        uploadButton
                      )}
                    </Upload>
                  </Form.Item>
                  <Form.Item
                    name="rewardHeadline"
                    label="Reward Headline"
                  >
                    <Input placeholder="Enter reward headline" />
                  </Form.Item>

                  <Flex>
                    <Form.Item
                      name="rewardHeadlineFontColor"
                      style={{ width: "250px" }}
                      label="Reward Headline Font Color"
                      getValueFromEvent={(color) => {
                        return "#" + color.toHex();
                      }}
                    >
                      <ColorPicker
                        showText
                        defaultValue="white"
                        value={rewardHeadlineFontColor}
                        onChange={(color) => handleColorChange(color, setRewardHeadlineFontColor)}
                      />
                    </Form.Item>

                    <Form.Item
                      name="rewardHeadlineFontSize"
                      style={{ width: "250px", marginLeft: "20px" }}
                      label="Reward Headline Font Size"
                    >
                      <Input
                        type="number"
                        min={1}
                        placeholder="Enter font size"
                        addonAfter="px"
                      />
                    </Form.Item>
                  </Flex>

                  <Form.Item
                    name="rewardDescription"
                    label="Reward Description"
                    maxLength="100"
                    rules={[
                      {
                        required: false                        },
                    ]}

                  >
                    <TextEditor />
                  </Form.Item>

                  <Flex>
                    <Form.Item
                      name="rewardDescriptionFontColor"
                      style={{ width: "250px" }}
                      label="Reward Description Font Color"
                      getValueFromEvent={(color) => {
                        return "#" + color.toHex();
                      }}
                    >
                      <ColorPicker
                        showText
                        defaultValue="white"
                        value={rewardDescriptionFontColor}
                        onChange={(color) => handleColorChange(color, setRewardDescriptionFontColor)}
                      />
                    </Form.Item>

                    <Form.Item
                      name="rewardDescriptionFontSize"
                      style={{ width: "250px", marginLeft: "20px" }}
                      label="Reward Description Font Size"
                    >
                      <Input
                        type="number"
                        min={1}
                        placeholder="Enter font size"
                        addonAfter="px"
                      />
                    </Form.Item>
                  </Flex>



                  <Form.Item>
                    <Space>
                      <Button
                        shape="round"
                        className="badge-btn-dark"
                        type="primary"
                        success
                        htmlType="submit"
                        icon={<StarOutlined />}
                      >
                        Update
                      </Button>
                      <Button
                        htmlType="button"
                        shape="round"
                        danger
                        onClick={resetRewardTab}
                      >
                        Reset
                      </Button>
                    </Space>
                  </Form.Item>
                </Flex>
              </TabPane>
            </Tabs>
          </Form>
        </Col>
        <Col span={8}>
          <Flex
            style={{
              backgroundImage: backgroundImageURL
                ? `url(${backgroundImageURL})`
                : "none",
              backgroundSize: "cover",
              backgroundColor: form.getFieldValue('backgroundColor') || badgeData.backgroundColor || backgroundColor,
              color: form.getFieldValue('fontColor') || badgeData.fontColor || fontColor,
            }}
            className="w-100 h-100 rounded-10"
            vertical
            justify="space-between"
          >
            {previewData.headline || badgeData.headline ? (
              <>
                <div className="text-center p-15">
                  <h3>Magic Badge Preview</h3>
                  <Image
                    src={imageUrl || badgeData.imageURL}
                    alt="Badge"
                    style={{
                      width: "150px",
                    }}
                  />
                  <h3 style={{
                    color: previewData.headlineFontColor || badgeData.headlineFontColor || headlineFontColor,
                    fontSize: previewData.headlineFontSize || badgeData.headlineFontSize ? `${previewData.headlineFontSize || badgeData.headlineFontSize}px` : 'inherit',
                    fontFamily: previewData.font || badgeData.font ? `"${previewData.font || badgeData.font}"` : 'inherit'
                  }}>
                    {previewData.headline || badgeData.headline}
                  </h3>
                  <div
                    style={{
                      color: previewData.fontColor || badgeData.fontColor || fontColor,
                      fontSize: previewData.fontSize || badgeData.fontSize ? `${previewData.fontSize || badgeData.fontSize}px` : 'inherit',
                      fontFamily: previewData.font || badgeData.font ? `"${previewData.font || badgeData.font}"` : 'inherit'
                    }}
                    dangerouslySetInnerHTML={{
                      __html: previewData.description || badgeData.description,
                    }}
                  />
                  {(previewData.buttonName || badgeData.buttonName) && (
                    <Button
                      href={previewData.buttonLinkURL || badgeData.buttonLinkURL}
                      style={{
                        backgroundColor: previewData.buttonColor || badgeData.buttonColor,
                        color: previewData.buttonTextColor || badgeData.buttonTextColor,
                        border: 'none',
                        fontSize: previewData.fontSize || badgeData.fontSize ? `${previewData.fontSize || badgeData.fontSize}px` : 'inherit',
                        fontFamily: previewData.font || badgeData.font ? `"${previewData.font || badgeData.font}"` : 'inherit'
                      }}
                    >
                      {previewData.buttonName || badgeData.buttonName}
                    </Button>
                  )}
                </div>
                <div>
                  {(previewData.videoURL || badgeData.videoURL) && typeof (previewData.videoURL || badgeData.videoURL) === 'string' && (
                    isYouTubeURL(previewData.videoURL || badgeData.videoURL) ? (
                      <iframe
                        className="prev-video"
                        width="100%"
                        height="315"
                        src={(previewData.videoURL || badgeData.videoURL).replace('watch?v=', 'embed/')}
                        title={previewData.name || badgeData.name}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe>
                    ) : (
                      <video
                        className="prev-video"
                        width="100%"
                        height="315"
                        controls
                      >
                        <source src={previewData.videoURL || badgeData.videoURL} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    )
                  )}
                </div>
              </>
            ) : (
              <div className="flex-empty">
                <Empty
                  className=""
                  image={magic}
                  imageStyle={{ height: 150 }}
                  description={<span>Fill Out the Form and Click Preview</span>}
                ></Empty>
              </div>
            )}
          </Flex>
        </Col>
      </Row>
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner" />
        </div>
      )}
      <Modal
        /*         width="800px"
         */ title={
          <>
            <InfoCircleOutlined style={{ color: "red" }} />
            {"\tConfirmation"}
          </>
        }
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => updateBadge()}
        okText={"Update Badge"}
      >
        <p>
          There are {recordCount} records with these criterias. Do you want to
          proceed to save badge with these criterias?
        </p>
      </Modal>
    </div>
  );
};

export default BadgeEdit;

